import gql from 'graphql-tag'

export default gql`
	mutation updateLoyaltyCardGroup($id: ID!, $fields: LoyaltyCardGroupCharacter!) {
		cashAssist {
			updateLoyaltyCardGroup(id: $id, fields: $fields) {
				id
                name
			}
		}
	}
`
